import React from 'react';
import { ThemeProvider } from 'styled-components';
import { DefaultTheme, DarkTheme } from '../components/Themes';
const initialValues = {
    theme: 'default',
};
/**
 * Use this theme provider wrapper when you need to add TruSTAR themes to isolated components some where.
 * Or if you want to use a redux store, you can connect this module.
 * @param props
 */
export const DesignSystemProvider = (props) => {
    const { className = '', theme = 'default' } = props;
    const classNameWithTheme = `${className} ts-${theme}`; // Append class name to the provider in case you need a css class to grab
    const themeConfiguration = theme === 'dark' ? DarkTheme : DefaultTheme;
    return (React.createElement("div", { className: classNameWithTheme },
        React.createElement(ThemeProvider, { theme: themeConfiguration }, props.children)));
};
